import { Heading, themes } from '@digitools/honest-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { TEALIUM_PAGE_VIEW } from '../../../constants/tealiumConstants';
import useTealium from '../../../hooks/useTealium';
import useTranslate from '../../../hooks/useTranslate';
import ContactUsText from './ContactUsText';
import ContactInfoBox from '../shared/ContactInfoBox';
// TODO: this should probably live inside honest's global styles
const ColoredListItem = styled('li') `
  ::marker {
    color: ${themes.rebrand.palette.primaryDark};
    margin-right: 0.15rem important!;
  }
`;
const ContactUs = () => {
    const { t } = useTranslate();
    const { trackView } = useTealium();
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_PAGE_VIEW.PAGE_L3.CONTACT_US,
            page_l4: TEALIUM_PAGE_VIEW.PAGE_L4.CONTACT_US.VIEW,
        });
    }, []);
    return (<div id='contactUsPublic' data-testid='contactUsPublic' style={{ padding: '2rem' }}>
      <Heading elemType={'h1'} elemStyle={'h1'}>
        {t(ContactUsText.heading)}
      </Heading>
      <Heading elemType={'h2'} elemStyle={'h2'} style={{ color: `${themes.rebrand.palette.primaryDark}` }}>
        {t(ContactUsText.subHeading)}
      </Heading>
      <br />
      <p>
        <Heading elemType={'h3'} elemStyle={'h3'}>
          {t(ContactUsText.requestHeading)}
        </Heading>
        <p>{t(ContactUsText.requestText)}</p>
      </p>
      <br />
      <p>
        <Heading elemType={'h3'} elemStyle={'h3'}>
          {t(ContactUsText.claimHeading)}
        </Heading>
        <p>
          <ul>
            <ColoredListItem>
              <span style={{ color: 'black' }}>{t(ContactUsText.stdText)}</span>
            </ColoredListItem>
            <ColoredListItem>
              <span style={{ color: 'black' }}>{t(ContactUsText.ltdText)}</span>
            </ColoredListItem>
          </ul>
        </p>
      </p>
      <br />
      <Heading elemType={'h3'} elemStyle={'h3'}>
        {t(ContactUsText.registrationHelpHeader)}
      </Heading>
      {t(ContactUsText.registrationHelpText)}
      <ContactInfoBox />
    </div>);
};
export default ContactUs;
